import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { AxiosRequestConfig } from "axios";

export interface User {
  name: string,
  mobile: string,
  created_at: string,
}

@Module
export default class UserModule extends VuexModule {
  users = [] as Array<User>
  user_count = 0

  get currentUsers(): Array<User> {
    return this.users;
  }

  get currentUserCount() {
    return this.user_count;
  }

  @Mutation
  [Mutations.SET_USERS](users) {
    this.users = users;
  }

  @Mutation
  [Mutations.SET_USER_COUNT](user_count) {
    this.user_count = user_count;
  }

  @Action
  [Actions.GET_USERS](params) {
    ApiService.setHeader();

    let queryString = "?";

    if (params) {
      Object.keys(params).forEach((i) => {
        queryString += "&" + i + "=" + params[i];
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/users", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_USERS, data["users"]);
          this.context.commit(Mutations.SET_USER_COUNT, data["total_result"]);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }
}
